export const pages = [
  "Dashboard",
  "Patient",
  "Tasks",
  "Contact-directory",
  "Inventory",
  "Documents",
  "Reports",
  "Unsigned-visits",
  "Settings",
];
export const settings = ["Profile", "Logout"];
